/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function CollectionNew({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M12.948.555a.6.6 0 0 0-.6.6v1.81h-1.734a.6.6 0 0 0 0 1.2h1.734V5.9a.6.6 0 0 0 1.2 0V4.165h1.811a.6.6 0 1 0 0-1.2h-1.811v-1.81a.6.6 0 0 0-.6-.6ZM.4 6.445V3A1.6 1.6 0 0 1 2 1.4h3.063a1.6 1.6 0 0 1 1.6 1.563h1.243a.6.6 0 1 1 0 1.2H6.063a.6.6 0 0 1-.6-.6V3a.4.4 0 0 0-.4-.4H2a.4.4 0 0 0-.4.4v1.932h8.478a.6.6 0 1 1 0 1.2H1.6V12A1.4 1.4 0 0 0 3 13.4h10a1.4 1.4 0 0 0 1.4-1.4V7.36a.6.6 0 1 1 1.2 0V12a2.6 2.6 0 0 1-2.6 2.6H3A2.6 2.6 0 0 1 .4 12V6.446Z" clipRule="evenodd" /></svg>;
}
;